/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".report[_ngcontent-%COMP%]{margin-top:50px}.report[_ngcontent-%COMP%]   .report-error[_ngcontent-%COMP%]{margin-left:24px;margin-right:24px}.public-link[_ngcontent-%COMP%]{float:right;margin-right:40px}"];
export { styles as styles };
